var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4697 1.46967C11.7626 1.17678 12.2374 1.17678 12.5303 1.46967L17.5303 6.46967C17.8232 6.76256 17.8232 7.23744 17.5303 7.53033C17.2374 7.82322 16.7626 7.82322 16.4697 7.53033L12.75 3.81066V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V3.81066L7.53033 7.53033C7.23744 7.82322 6.76256 7.82322 6.46967 7.53033C6.17678 7.23744 6.17678 6.76256 6.46967 6.46967L11.4697 1.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12H4C2.89543 12 2 12.8954 2 14V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V14C22 12.8954 21.1046 12 20 12H14.25V17C14.25 18.2426 13.2426 19.25 12 19.25C10.7574 19.25 9.75 18.2426 9.75 17V12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitUp);
export default __webpack_public_path__ + "static/media/exit-up.173cda1c73bd8362ade13c8e9461d283.svg";
export { ForwardRef as ReactComponent };